import { SEED_THEME } from '@/lib/seed-theme';
import type { AuthoringDoc, Step } from '@personalizehq/editor';
import type { Theme } from '@personalizehq/schemas/ir';
import bannerTop from './banner_top.json';
import bottomSheetConfirm from './bottom_sheet_confirm.json';
import fullscreenCarousel from './fullscreen_carousel_3step.json';
import modalBasic from './modal_basic.json';
import storySlide from './story_slide.json';

// The gallery. These are NEW curated documents, not fixtures: the fixture corpus is adversarial
// (`modal_adversarial`, `containers_adversarial`) — it exists to break the solver, not to start a
// design from. Zero renderer code either way; a template is data.
//
// ponytail: a template carries STEPS, not a theme. The spec has templates carrying their own theme
// "re-bound to the app theme's token names where they match" — but they are authored against the
// seed token names, so binding them to the app theme IS that re-bind, minus a diffing pass nobody
// needs yet. A template that used a token the app theme lacks would surface as an inline "not a
// token in this theme" on the field, which is the behaviour we want anyway.

export interface Template {
  id: string;
  name: string;
  description: string;
  steps: Step[];
}

export const TEMPLATES: Template[] = [
  { id: 'modal_basic', ...(modalBasic as Omit<Template, 'id'>) },
  { id: 'fullscreen_carousel_3step', ...(fullscreenCarousel as Omit<Template, 'id'>) },
  { id: 'bottom_sheet_confirm', ...(bottomSheetConfirm as Omit<Template, 'id'>) },
  { id: 'banner_top', ...(bannerTop as Omit<Template, 'id'>) },
  { id: 'story_slide', ...(storySlide as Omit<Template, 'id'>) },
];

/** Clone a template into a fresh draft, bound to the app's theme (or the seed, if the app has never
 *  written one — the API stores NULL until it does). The clone is deep: the module's imported JSON
 *  is shared across every "new experience" click. */
export function templateDoc(template: Template, theme: Theme | null | undefined): AuthoringDoc {
  return {
    doc_version: 1,
    theme: theme ?? SEED_THEME,
    steps: structuredClone(template.steps),
  };
}
